import { render, staticRenderFns } from "./Blocks.vue?vue&type=template&id=5c91ec3b&scoped=true&"
import script from "./Blocks.vue?vue&type=script&lang=ts&"
export * from "./Blocks.vue?vue&type=script&lang=ts&"
import style0 from "./Blocks.vue?vue&type=style&index=0&id=5c91ec3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c91ec3b",
  null
  
)

export default component.exports